import { render, staticRenderFns } from "./ProveedorGrid.vue?vue&type=template&id=91ff7200&"
import script from "./ProveedorGrid.vue?vue&type=script&lang=ts&"
export * from "./ProveedorGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports